import React, { useState } from 'react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { CalendarDays } from 'lucide-react';

const PRESETS = [
  { id: '7d', label: '7 days' },
  { id: '30d', label: '30 days' },
  { id: '90d', label: '90 days' },
  { id: '12m', label: '12 months' },
];

export function TimeRangeSelector({ activePeriod, onPeriodChange, onCustomRange }) {
  const [showCustom, setShowCustom] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const handlePreset = (id) => {
    setShowCustom(false);
    onPeriodChange(id);
  };

  const handleApplyCustom = () => {
    if (startDate && endDate) {
      onCustomRange(startDate, endDate);
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="time-range-selector">
      {PRESETS.map((p) => (
        <button
          key={p.id}
          onClick={() => handlePreset(p.id)}
          className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${
            activePeriod === p.id && !showCustom
              ? 'bg-[#1A1A1A] text-white'
              : 'bg-[#F9F6F0] text-stone-600 hover:bg-[#EAE4D9]'
          }`}
          data-testid={`period-${p.id}`}
        >
          {p.label}
        </button>
      ))}
      <button
        onClick={() => setShowCustom(!showCustom)}
        className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors flex items-center gap-1.5 ${
          showCustom || activePeriod === 'custom'
            ? 'bg-[#1A1A1A] text-white'
            : 'bg-[#F9F6F0] text-stone-600 hover:bg-[#EAE4D9]'
        }`}
        data-testid="period-custom"
      >
        <CalendarDays className="h-3.5 w-3.5" />
        Custom
      </button>

      {showCustom && (
        <div className="flex items-center gap-2 ml-2 animate-fadeIn">
          <Input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="input-zuriya text-sm h-9 w-36"
            data-testid="custom-start-date"
          />
          <span className="text-stone-400 text-sm">to</span>
          <Input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="input-zuriya text-sm h-9 w-36"
            data-testid="custom-end-date"
          />
          <Button
            size="sm"
            onClick={handleApplyCustom}
            disabled={!startDate || !endDate}
            className="btn-primary h-9 text-sm"
            data-testid="apply-custom-range"
          >
            Apply
          </Button>
        </div>
      )}
    </div>
  );
}
